import React from "react";
import "./SkinAssessmentButton.scss";

const SkinAssessmentButton = ({ children, btnClassName = '', onBtnClick = () => { }, disabled = false, type = "button" }) => {

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onBtnClick}
            className={`btn-skin ${btnClassName}`}>
            {children}
        </button>
    )
}

export default SkinAssessmentButton;